module.exports = __webpack_public_path__ + "img/13brice.cb9c8cae.jpg";